// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2MHtW","header":"MergedInvoice_header__3WW22"};